/* eslint-disable */

export default {
  getDespesas(state) {
    return state.despesas;
  },
  getColunasCabecalho(state) {
    return state.colunasCabecalho;
  },
  getFiltros(state) {
    return state.filtros;
  },
};
